import { Navigate } from 'react-router';

// User should fall here if returning from checkout success
const CheckoutCompletedScene = () => <Navigate replace to="/account/history" />;

export default CheckoutCompletedScene;
